import { css } from 'lit'

export default {
  sm: css`420px`,
  md: css`750px`,
  lg: css`1440px`,
}
